import { Component, Vue } from 'vue-property-decorator';
import Comment from '@/components/channel/Comment.vue';

// service
import { channelService } from '@/services/ChannelService';

// gql
import fetchChannelListQuery from '@/graphql/queries/channels/FetchChannelList.gql';

// types
import {
  CommunicationTypeEnum,
  fetchChannelList_channels
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    channelList: {
      query: fetchChannelListQuery,
      variables() {
        return { shipmentId: this.$route.params.id };
      },
      skip() {
        // skip if no inquiry/shipment id
        return !this.$route.params.id;
      },
      update(data) {
        // find public channel
        this.publicChannelId = data.channels.find((channel: fetchChannelList_channels) => {
          return channel.channelType === 'public';
        }).id;
        return data?.channels;
      }
    }
  },
  components: {
    Comment
  }
})
export default class commentsMixin extends Vue {
  channelList: fetchChannelList_channels[] | null = null;
  publicChannelId: string | null = null;

  async sendComment(content: string) {
    if (!this.publicChannelId) {
      return;
    }

    try {
      const communicationInput = {
        communicationType: CommunicationTypeEnum.text,
        content
      };

      const response = await channelService.createChannelMessage(
        communicationInput,
        this.publicChannelId
      );

      if (response) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.added'),
          time: 2000
        });
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }
}
